import api from '../../services/api'

// export const getRespondents = async ({commit, rootState}) => {
//   let respondents = await api.distributionService.getRespondents(rootState.survey.activeSurvey.hash)
//   for (let respondent of respondents.items) {
//     respondent.clicked = false
//   }
//   commit('SET_RESPONDENTS', respondents.items)
// }

// export const updateRespondent = async ({commit, state}, respondentHash, field, value) => {
//   // Update api
//   const respondent = state.respondents.find(respondent => {
//     return respondent.hash === respondentHash
//   })
//   respondent[field] = value
// }

export const searchRespondents = async ({rootState}, searchValue) => {
  const API_LIMIT = 50
  let i = 0
  let response = []
  let searchResults = []

  do {
    response = await api.userService.getUserByEmail(
      {
        fh: rootState.survey.activeSurvey.fid,
        'search[email]': searchValue,
        limit: API_LIMIT,
        offset: API_LIMIT * i++
      })

    searchResults.push(response)
  } while (response.length === API_LIMIT)

  if (searchResults[0].length < 1) return [] // no results

  let uhBulk = searchResults.map(searchBulk => searchBulk.map(user => user.uh));

  let promises = uhBulk.map(async uh => {
    return await api.userService.getFormUsers(rootState.survey.activeSurvey.fid, {uh: uh.join(';')})
  })

  return (await Promise.all(promises)).flat()
}

export const setRespondentNoRemind = async ({state}, {uid, noReminder, fid}) => {
  return api.surveyService.putUserNoReminder({noReminder: noReminder, fid: fid, uid: uid})
}

export const updateRespondentFields = async ({state}, {uid, email, noReminder, fid}) => {
  await api.surveyService.putFormUserFields({email: email, noReminder: noReminder, fid: fid, uid: uid})
}

export const deleteRespondents = async ({rootState, commit, dispatch}, users) => {
  let response = await api.distributionService.deleteRespondents(rootState.survey.activeSurvey.fid, users)
  if (response.error) {
    return {error: 'something wrong'}
  }
  return {}
}

export const addRespondents = async ({commit, dispatch, rootState}, correctEmails) => {
  let response = await api.distributionService.setRespondents(rootState.survey['survey/getActiveSurvey'].fid, correctEmails)
  if (response.error) {
    return {error: 'something wrong'}
  }
  return {}
}

export const sendInviteToRespondents = async ({commit, dispatch, rootState, state}, inviteObject) => {
  const mailObject = {text: inviteObject.text, subject: inviteObject.subject}
  const respondents = inviteObject.inviteRespondents

  // Always save mailtext
  await dispatch('survey/updateMailText', mailObject, {root: true})

  let params = {}

// Set overrides for sender en reply to email
  if(rootState.parantion.user.config){
    if (rootState.parantion.user.config.sender_email) {
      params.sender_email = rootState.parantion.user.config.sender_email
    }
    if (rootState.parantion.user.config.reply_to_email) {
      params.reply_to_email = rootState.parantion.user.config.reply_to_email
    }
  }

  // gather hashes from respondents is selected {
  if (respondents && respondents.length >= 1) {
    let respondentHashes = []
    let allRespondents = inviteObject.allRespondents

    for (let respondent of respondents) {
      if (respondent.progress[0].value === 0) {
        if (inviteObject.linkLogin) {
          respondentHashes.push({hash: respondent.uid, email: respondent.email})
        } else {
          respondentHashes.push(respondent.uid)
        }
        let originalRespondent = allRespondents.find(originalRespondent => {
          return respondent.uid === originalRespondent.uid
        })
        // changes status to queue
        originalRespondent.progress[0].value = 1
      }
    }
    // Update respondents in cash
    if (respondentHashes.length >= 1) {

      params.fid = rootState.survey.activeSurvey.fid
      params.userHashArray = respondentHashes
      params.linkLogin = inviteObject.linkLogin
      params.mail = mailObject

      await api.distributionService.sendInvite(params)
    }
  } else {
    // send mail to all users

    params.fid = rootState.survey.activeSurvey.fid
    params.linkLogin = inviteObject.linkLogin
    params.mail = mailObject

    await api.distributionService.sendInvite(params)
  }
}

export const sendReminderToRespondents = async ({commit, dispatch, rootState, state}, remindObject) => {
  const mailObject = {text: remindObject.text, subject: remindObject.subject}
  const respondents = remindObject.remindRespondents


  await dispatch('survey/updateReminderMailText', mailObject, {root: true})

  let params = {}

  // Set overrides for sender en reply to email
  if(rootState.parantion.user.config){
    if (rootState.parantion.user.config.sender_email) {
      params.sender_email = rootState.parantion.user.config.sender_email
    }
    if (rootState.parantion.user.config.reply_to_email) {
      params.reply_to_email = rootState.parantion.user.config.reply_to_email
    }
  }

  // gather hashes from respondents is selected {
  if (respondents && respondents.length >= 1) {
    let respondentHashes = []
    let respondentsProcessed = []
    let allRespondents = remindObject.allRespondents

    for (let respondent of respondents) {
      if (respondent.progress[0].value >= 2 && respondent.progress[0].value <= 4) {
        respondentHashes.push(respondent.uid)
        let originalRespondent = allRespondents.find(originalRespondent => {
          return respondent.uid === originalRespondent.uid
        })
        // changes status to queue
        originalRespondent.progress[0].value = 3
        respondentsProcessed.push(originalRespondent)
      }
    }
    // Update respondents in cash
    if (respondentsProcessed.length >= 1) {

      params.fid = rootState.survey.activeSurvey.fid
      params.userHashArray = respondentHashes
      params.linkLogin = remindObject.linkLogin
      params.mail = mailObject

      await api.distributionService.sendReminder(params)
    }
  } else {
    // send mail to all users
    params.fid = rootState.survey.activeSurvey.fid
    params.linkLogin = remindObject.linkLogin
    params.mail = mailObject

    await api.distributionService.sendReminder(params)
  }
}

/**
 * Reset the job store
 * @param state
 * @constructor
 */
export const RESET = ({commit}) => {
  commit('RESET')
}
